import { render, staticRenderFns } from "./WhatsSet.vue?vue&type=template&id=35c5ee6c"
import script from "./WhatsSet.vue?vue&type=script&lang=js"
export * from "./WhatsSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports